import { html } from 'lit';
import { Clock } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-clock')
export class PdsIconClock extends PdsIcon {
  @state()
  icon = Clock;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
